// extracted by mini-css-extract-plugin
module.exports = {"customList":"mediaListText_customList__p_Qkg"};